import React from "react";
import styled from "styled-components";

const Cells = styled.div`
  display: flex;
  align-items: center;
`;

export default (props) => <Cells {...props} />;
